var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{attrs:{"justify":"center"}},[(_vm.countEvent > 0)?_c('span',{staticClass:"notification"},[_vm._v(_vm._s(_vm.countEvent))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }